module.exports = __webpack_public_path__ + "img/voice_202307_01.211dbc70.jpg";